/**
 * @generated SignedSource<<7d4ba252a4f37fa790e090d0ec567736>>
 * @relayHash 392e0e385ab7072bf6c9d053794fffa3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 392e0e385ab7072bf6c9d053794fffa3

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type chChatHistorySummarizerQuery$variables = {
  aiRequestMetadata: AiRequestMetadataInput;
};
export type chChatHistorySummarizerQuery$data = {
  readonly summarizeChatAppointment: {
    readonly aiAnonymizationRequestDurationMs: number;
    readonly aiRequestDurationMs: number;
    readonly fileHash: string;
    readonly result: AiResult;
    readonly text: string;
  };
};
export type chChatHistorySummarizerQuery = {
  response: chChatHistorySummarizerQuery$data;
  variables: chChatHistorySummarizerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiRequestMetadata"
  }
],
v1 = [
  {
    "alias": "summarizeChatAppointment",
    "args": [
      {
        "kind": "Variable",
        "name": "aiRequestMetadata",
        "variableName": "aiRequestMetadata"
      }
    ],
    "concreteType": "TextResult",
    "kind": "LinkedField",
    "name": "ch_summarizeChatAppointment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiRequestDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiAnonymizationRequestDurationMs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chChatHistorySummarizerQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chChatHistorySummarizerQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "392e0e385ab7072bf6c9d053794fffa3",
    "metadata": {},
    "name": "chChatHistorySummarizerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "845ad16d10bffed5160525e69e4c739d";

export default node;
